<template>
    <SearchLayout :get-data="readUrlsByThematic()" :search-at-creation="true" />
</template>

<script>
    import SearchLayout from '@/components/Search/SearchLayout.vue'
    import NlSearchFilters from '@/components/Search/NlSearchFilters.vue'
    import elasticUrlsRepository from '@/api/v2/elastic/url'

    export default {
        name: 'SearchByThematic',
        title: 'searchform.searchByTheme.title',
        components: {
            NlSearchFilters,
            SearchLayout
        },
        methods: {
            readUrlsByThematic() {
                return elasticUrlsRepository.readUrlsByThematic
            }
        }
    }
</script>
